import { ConfirmationComponent } from 'app/home/sidebar/confirmation/confirmation';
import { ActivatedRoute } from '@angular/router';
import { Agenda } from 'app/model/agenda';
import { Agende } from 'app/model/agende';
import { SettingsComponent } from 'app/impostazioni_agenda/impostazioni_agenda';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Component } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { MeasureService } from 'app/measure.service';

@Component({
	selector: 'app-sidebar',
	templateUrl: './sidebar.html',
	styleUrls: ['./sidebar.css']
})

export class SidebarComponent {

	pending: Promise<any> = Promise.resolve(true);
	mobileView: boolean;

	// Parameters subscription
	private paramsSubscription: Subscription;

	constructor(protected route: ActivatedRoute,
		private modalService: NgbModal,
		public agende: Agende,
		measureService: MeasureService
	) {
		this.mobileView = measureService.isMobile();
	}

	removeAgenda(agenda: Agenda, $event: MouseEvent) {
		const modalRef = this.modalService.open(ConfirmationComponent);
		modalRef.componentInstance.setElementoDaCancellare(agenda.nome);
		modalRef.result
			.then(() => {
				this.pending = this.agende.delete(agenda);
			})
			// Non faccio nulla se l'utente decide di non cancellare
			.catch(() => { });
		$event.stopPropagation();
		$event.preventDefault();
	}

	settings(agenda: Agenda, $event: MouseEvent) {
		const modalRef = this.modalService.open(SettingsComponent, {size: "lg"});
		modalRef.componentInstance.setAgenda(agenda);
		$event.stopPropagation();
		$event.preventDefault();
	}
}



// WEBPACK FOOTER //
// ./src/app/home/sidebar/sidebar.ts